/**
 * Cap on the additional notification addresses of an experience
 * (experiences.notify_emails). An anti-abuse measure, not a technical limit —
 * decided at 10 in story 04.1. One constant serves both the check and the
 * error message, so they cannot drift apart.
 */
export const MAX_NOTIFY_EMAILS = 10
